export const rttReportingEn = {};

export const rttReportingFr = {};
